// @flow
import * as React from 'react';
import { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import SearchView from 'containers/search';
import { NetworkReviewFieldsets as ReviewFieldsets } from './SearchForm';
import { networkSearch } from 'api/content/search';
import SyndicationCopy from './NetworkSearchCopy';
import { ClientContext } from 'containers/client/ClientProvider';
import { getIsPwrDistroClient } from 'components/ModerationCard/ClientModerationCard/utils';

const label = 'Network Reviews';
const NetworkReviewSearch = (props: *) => {
  const clientProps = useContext(ClientContext);

  if (clientProps && getIsPwrDistroClient(clientProps.clientId, clientProps)) {
    const { location } = props;
    const newPathname = location.pathname.replace(
      '/network-reviews',
      '/reviews-search'
    );
    return <Redirect to={{ pathname: newPathname, search: location.search }} />;
  }

  const { hideCopy, ...rest } = props;

  return (
    <SearchView
      label={label}
      primaryFieldsets={ReviewFieldsets.primaryFieldsets}
      extraFieldsets={ReviewFieldsets.extraFieldsets}
      method={networkSearch}
      copy={hideCopy ? null : <SyndicationCopy />}
      {...rest}
    />
  );
};

NetworkReviewSearch.label = label;

export default NetworkReviewSearch;



// WEBPACK FOOTER //
// ./src/containers/search/NetworkReviews.js